import React, { useRef } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import GemIcon from "@/components/premium/gem-icon";
import HomeLogo from "@/components/home-logo";
import { Avatar, HStack, Text } from "@/components/ui";
import { useAuth } from "@/contexts/auth/useAuth";
import { useSidebarMenuContext } from "@/contexts/sidebar-menu-context";
import { cn } from "@/utils/cn";

const Navbar = () => {
  const { currentAccount } = useAuth();
  const { setIsSidebarOpen } = useSidebarMenuContext();

  const node = useRef(null);

  const onOpenSidebar = () => setIsSidebarOpen(true);

  return (
    <nav
      className="sticky top-0 z-51 border-b bg-background lg:hidden"
      ref={node}
      data-testid="navbar"
    >
      <div className="mx-auto max-w-7xl px-2 sm:px-6">
        <div className="relative flex h-16 justify-between">
          {currentAccount && (
            <div className="absolute inset-y-0 left-0 flex items-center rtl:right-0 rtl:left-auto">
              <button
                onClick={onOpenSidebar}
                className="flex items-center -space-x-2.5"
              >
                <Avatar src={currentAccount.avatar_static} size={34} />

                <HStack
                  alignItems="center"
                  space={0.5}
                  className={cn("relative", {
                    grayscale: !currentAccount.premium,
                  })}
                >
                  <GemIcon
                    className="size-5"
                    strokeClassName="stroke-background"
                  />

                  <Text weight="bold" size="xs" theme="secondary">
                    {currentAccount.source.gems_count}
                  </Text>
                </HStack>
              </button>
            </div>
          )}

          <HStack
            space={4}
            alignItems="center"
            className={cn("flex-1", {
              "justify-center": currentAccount,
              "justify-start": !currentAccount,
            })}
          >
            <Link
              key="logo"
              to="/"
              data-preview-title-id="column.home"
              className="ml-4 flex shrink-0 items-center"
            >
              <HomeLogo alt="Logo" className="h-5 w-auto cursor-pointer" />
              <span className="hidden">
                <FormattedMessage id="tabs_bar.home" defaultMessage="Home" />
              </span>
            </Link>
          </HStack>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
